import { ReactElement } from "react";

import ChangeQuantityCTAVisual from "@/components/CallToActions/ChangeQuantityCTAVisual/changeQuantityCTAVisual.component";
import { CartItemModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import { CTAActions } from "@/redux/modules/api/data/cart/@types/cart.types";

const changeQuantityCTAVisual = (
    product: CartItemModel | null,
    action: CTAActions
): ReactElement => {
    const actualQuantity = action.productParameters[1];
    return (
        <ChangeQuantityCTAVisual
            actualQuantity={actualQuantity}
            type={action.type}
            sku={product?.sku}
        />
    );
};

export default changeQuantityCTAVisual;
